export const en = {
    'suggest-request-error': 'Error while handling participants',
};
